import Vue from 'vue'
import BaseBtn from '@/components/base/Btn'
import BaseHeading from '@/components/base/Heading'
import BaseSubheading from '@/components/base/Subheading'
import BaseText from '@/components/base/Text'

Vue.component('BaseBtn', BaseBtn)
Vue.component('BaseHeading', BaseHeading)
Vue.component('BaseSubheading', BaseSubheading)
Vue.component('BaseText', BaseText)
